module.exports = __webpack_public_path__ + "static/media/springBg.033582fd.jpeg";